// extracted by mini-css-extract-plugin
export var hidden = "_70-1";
export var visible = "_70-0";